export default __webpack_public_path__ + "static/media/profile-pic-placeholder.7caf2186.png";